<template>
  <div class="ncl">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="ableFlag">
      <home-header @postrefresh="getFlag" @getQuotaCard="getQuotaCard" @getswiper="getswiperdata" ref="entiretychild"></home-header>
      <home-swiper :swiperList="swiperListResult" @changeswiper="changeswiperdata"></home-swiper>
      <quota-card :quotaCard="quotaCard" @getFlag1="getFlag1"></quota-card>
      <smartbi-chart ref="entiretyChart"></smartbi-chart>
<!--      <home-charts></home-charts>-->
    </van-pull-refresh>
  </div>
</template>

<script>
import HomeHeader from './components/Header'
import HomeSwiper from './components/Swiper'
import QuotaCard from './components/EntiretyCard'
import HomeCharts from './components/Charts'
import SmartbiChart from './components/SmartbiChart'

export default {
  name: 'EntiretyCard',
  components: {
    HomeHeader,
    HomeSwiper,
    QuotaCard,
    HomeCharts,
    SmartbiChart
  },
  data () {
    return {
      codeAndName: '',
      isLoading: false,
      swiperListResult: null,
      quotaCard: null,
      ableFlag: false
    }
  },
  methods: {
    getswiperdata (data) {
      this.swiperListResult = data
    },
    getQuotaCard (data) {
      this.quotaCard = data
    },
    // 控制下拉刷新
    getFlag (data) {
      this.ableFlag = data
    },
    getFlag1 (data) {
      this.ableFlag = data
    },
    changeswiperdata (data) {
      this.quotaCard = data
    },
    onRefresh () {
      this.isLoading = true
      this.$refs.entiretychild.getHomeInfo()
      this.$refs.entiretyChart.getQuotaDetailRe()
      // setTimeout(() => {
      //   this.$toast('刷新成功')
      //   this.isLoading = false
      // }, 500)
    }
  },
  mounted () {
    localStorage.setItem('moreTextFlag', 1)
  },
  watch: {
    ableFlag () {
      // 数据加载完成
      if (!this.ableFlag && this.isLoading) {
        this.$toast('刷新成功')
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.ncl {
  padding-top: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/EntiretyHome.vue